import { render, staticRenderFns } from "./BaseDatePicker.vue?vue&type=template&id=2bd523b6&scoped=true&"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js&"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseDatePicker.vue?vue&type=style&index=0&id=2bd523b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd523b6",
  null
  
)

export default component.exports